import { Component, OnInit } from "@angular/core";
import { RoutingConstants } from "src/app/constants/routingConstants";
import { MenuConstants } from "src/app/constants/menuConstants";
import { TokenService } from "../../core/services/token.service";
import { AuthService } from "../../core/services/auth.service";
import { ToastrAlertService } from "../../core/services/toastrAlert.service";
import { Router } from "@angular/router";
import { JwtDTO } from "src/app/core/models/jwt-dto";
import * as data from "../../../../package.json";

@Component({
  selector: "app-menu",
  templateUrl: "./menu.component.html",
  styleUrls: ["./menu.component.css"],
})
export class MenuComponent implements OnInit {
  isLogged = false;
  isAdmin = false;

  routingConstants = RoutingConstants;
  menuConstants = MenuConstants;
  navBarUserData;

  arrIcons = ["fas fa-caret-down", "fas fa-caret-right"];

  displayMenuUnFolded = false;
  menuPrincipal = this.menuConstants.menuPrincipal;

  public version: string;

  constructor(
    private tokenService: TokenService,
    private router: Router,
    private authService: AuthService,
    private toastrAlertService: ToastrAlertService
  ) {}

  ngOnInit() {
    this.version = data.version;
    this.isLogged = this.tokenService.isLogged();
    this.navBarUserData = this.tokenService.getNavbarData();

    if (
      document
        .getElementsByTagName("app-root")[0]
        .classList.value.includes("openedMenu")
    ) {
      this.displayMenuUnFolded = true;
    }

    document.addEventListener('click', this.handleClickOutside.bind(this));
  }

  ngOnDestroy() {
    document.removeEventListener('click', this.handleClickOutside.bind(this));
  }

  handleClickOutside(event) {
    if (window.innerWidth <= 790) {
      const menuElement = document.getElementById('sideMenu');
      const navbarToggler = document.querySelector('.navbar-toggler');
      if (menuElement && !menuElement.contains(event.target) && !navbarToggler.contains(event.target)) {
        this.closeMenu();
      }
    }
  }

  closeMenu() {
    let el: any = document.getElementsByTagName("app-root")[0];
    this.displayMenuUnFolded = false;
    el.classList.remove("openedMenu");
  }

  onLogOut(): void {
    const dto: JwtDTO = new JwtDTO(this.tokenService.getToken());
    this.authService.logout(dto).subscribe(
      (data) => {
        this.tokenService.logOut();
      },
      (err) => {
        this.toastrAlertService.toastrFail(err.error.mensaje);
      }
    );
  }

  clickToggleMenu() {
    let el: any = document.getElementsByTagName("app-root")[0];

    if (!this.displayMenuUnFolded) {
      this.displayMenuUnFolded = true;
      el.classList.add("openedMenu");
    } else {
      this.displayMenuUnFolded = false;
      el.classList.remove("openedMenu");
    }
  }

  clickToggleSideSubMenu(submenuId: string) {
    let index = this.menuPrincipal.findIndex((e) => e.id === submenuId);

    let newItem = this.menuPrincipal[index];

    if (newItem.subMenuStatus) {
      newItem.subMenuStatus = false;
    } else {
      newItem.subMenuStatus = true;
    }

    this.menuPrincipal[index] = newItem;
  }

  goList(url) {
    if (window.innerWidth <= 790) {
      this.closeMenu();
    }
    this.router.navigate([url]);
  }

  checkPermission(profiles) {
    let access = 0;
    profiles.forEach((role) => {
      access += this.tokenService.hasRole(role) ? 1 : 0;
    });
    return access > 0;
  }

  descripcionDelPerfil(codigoPerfil) {
    if (this.navBarUserData.descripcionesPerfiles == null) return codigoPerfil;
    const index = this.navBarUserData.perfiles.indexOf(codigoPerfil);
    if (this.navBarUserData.descripcionesPerfiles.length <= index)
      return codigoPerfil;
    return this.navBarUserData.descripcionesPerfiles[index];
  }

  onMouseLeave() {
    this.closeMenu();
  }

  onMouseEnter() {
    let el: any = document.getElementsByTagName("app-root")[0];
    this.displayMenuUnFolded = true;
    el.classList.add("openedMenu");
  }
}
